import { __assign, __extends } from "tslib";
import classNames from 'classnames';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import styles from './Modal.scss';
var ModalMode;
(function (ModalMode) {
    ModalMode["REGULAR"] = "REGULAR";
    ModalMode["PREVIEW"] = "PREVIEW";
})(ModalMode || (ModalMode = {}));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalStyles = {
            overlay: {
                // Overriding defaults
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: null,
                // Overriding defaults - END
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            },
            content: {
                // Overriding defaults
                border: 'none',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                padding: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'auto',
                height: '100%',
                // Overriding defaults - END
                backgroundColor: 'transparent',
                marginBottom: '0px',
            },
        };
        return _this;
    }
    Modal.setAppElement = function (appElement) {
        ReactModal.setAppElement(appElement);
    };
    Modal.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, onRequestClose = _b.onRequestClose, customStyles = _b.customStyles, isOpen = _b.isOpen, portalClassName = _b.portalClassName, mode = _b.mode;
        var modalStyles = __assign(__assign({}, this.modalStyles), customStyles);
        return (React.createElement(ReactModal, { isOpen: isOpen, style: modalStyles, shouldCloseOnOverlayClick: true, onRequestClose: onRequestClose, className: styles.modal, portalClassName: portalClassName || styles.portal, contentLabel: '', closeTimeoutMS: 600, overlayClassName: classNames(styles['overlay-modal-wrapper'], (_a = {},
                _a[styles.modalPreview] = mode === ModalMode.PREVIEW,
                _a)) }, children));
    };
    Modal.defaultProps = {
        customStyles: {},
        mode: ModalMode.REGULAR,
    };
    return Modal;
}(Component));
export { ModalMode };
export default Modal;
//# sourceMappingURL=Modal.js.map